function x(e, u) {
  e = e.slice();
  var t = 0, c = e.length - 1, f = e[t], l = e[c], r;
  return l < f && (r = t, t = c, c = r, r = f, f = l, l = r), e[t] = u.floor(f), e[c] = u.ceil(l), e;
}
export {
  x as default
};
